import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import { PhoneConfirmationContextProvider } from "./context/PhoneConfirmationContext";
import ErrorPage from "./pages/errorPage";
import SuccessPage from "./pages/successPage";

export default function Router() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route
          path="/"
          element={
            <PhoneConfirmationContextProvider>
              <Home />
            </PhoneConfirmationContextProvider>
          }
        />
        <Route
          path="/error"
          element={
            <PhoneConfirmationContextProvider>
              <ErrorPage />
            </PhoneConfirmationContextProvider>
          }
        />
        <Route
          path="/success"
          element={
            <PhoneConfirmationContextProvider>
              <SuccessPage />
            </PhoneConfirmationContextProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
